import api from "../../system/api";
import {getStorage} from "../../system/storage";

// «دستیار برنامه‌ریزی کار» (backend: src/tasks/schedule-assistant.ts in zofino-strapi;
// docs/tasks/35-schedule-assistant-progress-chart.md). Read only — choosing a suggestion never saves the task.
const data = (response) => response?.data?.data;
const config = (params) => ({headers: {workspace: getStorage("workspace")}, params, suppressGlobalErrorHandler: true});

export const scheduleAssistantApi = {
    // {assignee, start?, end? (ms), duration? (minutes), day? (YYYY-MM-DD), days? (7 | 14), exclude? (task documentId)}
    get: async (params) => data(await api.get("/schedule-assistant", config(params))),
};
